/* Halo Labs theme v2 interactions */
(function () {
  function initAccordions() {
    document.querySelectorAll('[data-halo-accordion]').forEach(function (group) {
      group.querySelectorAll('[data-halo-accordion-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('[data-halo-accordion-item]');
          if (!item) return;
          item.classList.toggle('open');
        });
      });
    });
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-halo-variant-picker]').forEach(function (picker) {
      picker.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          picker.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var evt = new CustomEvent('halo:variant-changed', {
            detail: { value: btn.dataset.value, kind: picker.dataset.haloVariantPicker }
          });
          picker.dispatchEvent(evt);
        });
      });
    });
  }

  function initPdpThumbs() {
    var main = document.querySelector('[data-halo-pdp-main]');
    if (!main) return;
    document.querySelectorAll('[data-halo-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-halo-pdp-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var type = thumb.getAttribute('data-media-type') || 'image';
        if (type === 'image') {
          var url = thumb.getAttribute('data-img-url');
          if (!url) return;
          main.innerHTML = '<img src="' + url + '" width="400" height="500" loading="eager" alt="">';
        } else {
          var id = thumb.getAttribute('data-media-id');
          var tpl = document.querySelector('[data-halo-media-template="' + id + '"]');
          if (!tpl) return;
          main.innerHTML = tpl.innerHTML;
        }
      });
    });
  }

  function initPdpQty() {
    document.querySelectorAll('[data-halo-qty]').forEach(function (row) {
      var input = row.querySelector('[data-halo-qty-input]');
      if (!input) return;
      var minus = row.querySelector('[data-halo-qty-minus]');
      var plus = row.querySelector('[data-halo-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        input.value = Math.max(1, v - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        input.value = v + 1;
      });
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function initPdpVariantSync() {
    var variants = window.__haloProductVariants;
    var options = window.__haloProductOptions;
    if (!variants || !options) return;
    var form = document.querySelector('.pdp-form');
    if (!form) return;

    function currentSelection() {
      var sel = {};
      document.querySelectorAll('[data-halo-variant-picker]').forEach(function (picker) {
        var pos = parseInt(picker.getAttribute('data-halo-option-position'), 10);
        var active = picker.querySelector('button.active');
        if (active) sel['option' + pos] = active.getAttribute('data-value');
      });
      return sel;
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        Object.keys(sel).forEach(function (k) {
          if (v[k] !== sel[k]) match = false;
        });
        if (match) return v;
      }
      return null;
    }

    function updateForVariant(v) {
      var hidden = form.querySelector('[data-halo-variant-id]');
      if (hidden) hidden.value = v.id;
      var priceEl = document.querySelector('[data-halo-price]');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var compareEl = document.querySelector('[data-halo-compare]');
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var addPriceEl = document.querySelector('[data-halo-add-price]');
      if (addPriceEl) addPriceEl.textContent = formatMoney(v.price);
      var splitEl = document.querySelector('[data-halo-split]');
      if (splitEl) {
        var splitCents = Math.ceil(v.price / 3);
        splitEl.textContent = splitCents % 100 === 0 ? (splitCents / 100) + ' €' : formatMoney(splitCents);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    document.querySelectorAll('[data-halo-variant-picker]').forEach(function (picker) {
      picker.addEventListener('halo:variant-changed', function (e) {
        var kind = picker.getAttribute('data-halo-variant-picker');
        var label = document.querySelector('[data-halo-option-current="' + kind + '"]');
        if (label) label.textContent = e.detail.value;
        var sel = currentSelection();
        var v = findVariant(sel);
        if (v) updateForVariant(v);
      });
    });
  }

  function initStickyBuyBar() {
    var bar = document.querySelector('[data-halo-sticky-buy-bar]');
    if (!bar) return;
    var ticking = false;
    function compute() {
      var y = window.scrollY;
      var showcase = document.getElementById('catalogue');
      var footer = document.querySelector('.footer');
      var passShowcase = showcase ? y > showcase.offsetTop - 200 : y > 800;
      var beforeFooter = footer ? y + window.innerHeight < footer.offsetTop + 80 : true;
      var visible = passShowcase && beforeFooter;
      bar.classList.toggle('visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(compute);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    compute();
  }

  // Barre d'achat collante de la fiche produit. Elle relaie le clic vers le vrai
  // bouton d'ajout, donc rien de la logique variante/quantité n'est dupliqué.
  function initPdpStickyBar() {
    var bar = document.querySelector('[data-halo-pdp-sticky]');
    var addBtn = document.querySelector('.pdp-add');
    if (!bar || !addBtn) return;

    var relay = bar.querySelector('[data-halo-pdp-sticky-add]');
    if (relay) {
      relay.addEventListener('click', function () { addBtn.click(); });
    }

    // Le prix du bouton principal est déjà tenu à jour par initPdpVariantSync :
    // on se contente de le recopier quand il change.
    var priceSrc = document.querySelector('[data-halo-add-price]');
    var priceDst = bar.querySelector('[data-halo-sticky-price]');
    if (priceSrc && priceDst && window.MutationObserver) {
      new MutationObserver(function () {
        priceDst.textContent = priceSrc.textContent;
      }).observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }

    var footer = document.querySelector('.footer');
    var ticking = false;
    function compute() {
      // getBoundingClientRect plutôt que offsetTop : insensible à l'offsetParent.
      var passed = addBtn.getBoundingClientRect().bottom < 0;
      var nearFooter = footer
        ? footer.getBoundingClientRect().top < window.innerHeight - 40
        : false;
      var visible = passed && !nearFooter;
      bar.classList.toggle('visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(compute);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    compute();
  }

  // Événements Microsoft Clarity (API events). Déclarés explicitement plutôt que
  // devinés par Clarity à partir du texte des boutons : insensible aux libellés,
  // et sans faux positif sur les CTA « Commander » qui ne sont que des liens.
  function initClarityEvents() {
    function track(name) {
      try {
        if (typeof window.clarity === 'function') window.clarity('event', name);
      } catch (e) { /* Clarity absent ou consentement refusé : on ignore. */ }
    }
    function tag(key, value) {
      try {
        if (typeof window.clarity === 'function') window.clarity('set', key, value);
      } catch (e) { /* idem */ }
    }

    var stickyBtn = document.querySelector('[data-halo-pdp-sticky-add]');
    if (stickyBtn) {
      // Enregistré AVANT le relais de initPdpStickyBar, donc exécuté avant lui.
      stickyBtn.addEventListener('click', function () { fromSticky = true; });
    }

    var addBtn = document.querySelector('.pdp-add');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        // La barre collante relaie son clic ici : l'événement n'est compté qu'une
        // fois, et le tag dit par quel bouton l'ajout est passé.
        tag('atc_source', fromSticky ? 'sticky' : 'main');
        fromSticky = false;
        track('add_to_cart');
      });
    }

    var checkoutBtn = document.querySelector('.cart-checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () { track('begin_checkout'); });
    }
  }
  var fromSticky = false;

  function init() {
    initAccordions();
    initVariantPickers();
    initPdpThumbs();
    initPdpQty();
    initPdpVariantSync();
    initStickyBuyBar();
    initClarityEvents();
    initPdpStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
